const LINKS = ["About Us","Privacy Policy","Terms of Service","GDPR / Data Rights","Cookie Settings","Support","Publisher Info"];

export function Footer() {
  return (
    <footer style={{ borderTop: "1px solid var(--border)", background: "var(--bg-surface)", padding: "32px 48px 40px", marginTop: 60 }}>
      <div style={{ maxWidth: 1440, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 28, flexWrap: "wrap", gap: 24 }}>
          <div>
            <div style={{ fontFamily: "var(--font-display)", fontSize: 28, fontWeight: 900, marginBottom: 10 }}>
              <span style={{ color: "var(--accent-bright)" }}>GS</span>
              <span style={{ color: "var(--text-muted)" }}>STORE</span>
            </div>
            <p style={{ color: "var(--text-muted)", fontSize: 13, maxWidth: 300, lineHeight: 1.7 }}>
              Discover, play, and publish games across all platforms. Built on a robust microservices architecture with 8+ services.
            </p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, auto)", gap: "8px 40px" }}>
            {LINKS.map((l) => (
              <span key={l} style={{ fontSize: 13, color: "var(--text-muted)", cursor: "pointer" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "var(--text-secondary)")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted)")}
              >{l}</span>
            ))}
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 1, marginBottom: 10 }}>Available On</div>
            {["🖥️ PC / Mac", "📱 iOS & Android", "🎮 Consoles"].map((s) => (
              <div key={s} style={{ fontSize: 13, color: "var(--text-secondary)", marginBottom: 6 }}>{s}</div>
            ))}
          </div>
        </div>
        <div style={{ borderTop: "1px solid var(--border)", paddingTop: 20, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
          <span style={{ color: "var(--text-muted)", fontSize: 13 }}>© {new Date().getFullYear()} GameStore Platform Inc.</span>
          <span style={{ color: "var(--text-muted)", fontSize: 12 }}>React + TypeScript · Vite · Zustand</span>
        </div>
      </div>
    </footer>
  );
}
